<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>

<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Saved Searches'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>

  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button1-id'" [label]="'Reset Filter'"
                                (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                      [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"
      ></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                      [idVal]="'top-save-button-id'" [label]="'Submit and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"
      ></app-st-button>
    </div>
    <br>

    <div id="DONOR_SEARCH">
      <app-st-header-title [inputVal]="'Search Donors Filters Template'"></app-st-header-title>
      <div>
        <app-st-input-text [idVal]="'donor-search-filter-name-text-id'" [label]="''" [placeHolderVal]="'Donor Search Filter Name'" [inputVal]="savedDonorSearchName" [width]="'90%'"
            [maxLength]="100" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Include Foundation Names: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple foundation names by commas.'"></app-st-span>
        <!--<app-st-input-text [idVal]="'donor-name-with-text-id'" [label]="''" [placeHolderVal]="'Foundation Name (With)'" [inputVal]="donor_namesInput" [width]="'90%'"
                           [maxLength]="200"
        ></app-st-input-text>-->
        <app-st-autocomplete [idVal]="'donor-name-with-text-id'" [label]="''" [placeHolderVal]="'Foundation Name (With)'" [maxLength]="200" [width]="'95%'"
                             [inputVal]="donor_namesInput"
                             [items]="this.companyNamesAutocomplete" [multipleAllowed]="true"
                             [disabled]="this.readOnly"
        ></app-st-autocomplete>
        <br>
        <!--
        <app-st-span [inputVal]="'Exclude Foundation Names: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple foundation names by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'donor-name-without-text-id'" [label]="''" [placeHolderVal]="'Foundation Name (Without)'" [inputVal]="donor_namesWithoutInput" [width]="'90%'"
                           [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>-->
        <app-st-span [inputVal]="'Include EINs: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'donor-ein-text-id'" [label]="''" [placeHolderVal]="'Include EINs'" [width]="'90%'"
                           [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <!--
        <div>
          <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioIncludeRevocationList"
                 (click)="toggleRevokeLogicalExpression()" [checked]="includeTaxExemptRevoked">
          <label class="form-check-label checkbox-text webtext-black" for="flexRadioIncludeRevocationList">
            &nbsp;Include Orgs In Tax Exempt Revocation List
          </label>
        </div>-->
        <app-st-span [inputVal]="'Include Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
        <app-st-autocomplete-key-lookup [idVal]="'donor-cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                        [inputVal]="donor_citiesInput"
                                        [items]="this.citiesAutocomplete"
                                        [disabled]="this.readOnly"
        ></app-st-autocomplete-key-lookup>
        <br>
        <!--
        <app-st-span [inputVal]="'Exclude Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
        <app-st-input-text [idVal]="'donor-cities-without-text-id'" [label]="''" [placeHolderVal]="'Without Cities'" [inputVal]="donor_citiesWithoutInput" [width]="'90%'"
                           [maxLength]="200" [disabled]="this.readOnly"
        ></app-st-input-text>-->
        <app-st-span [inputVal]="'State: '" class="webtext-black-bold"></app-st-span>
        <app-st-select *ngIf="!this.readOnly" [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.donor_statesList"></app-st-select>
        <app-st-input-text  *ngIf="this.readOnly" [idVal]="'usa-state-text-id'" [label]="''" [placeHolderVal]="'State'"
                            [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Zip Code: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'donor-zip-code-text-id'" [label]="''" [placeHolderVal]="'Zip Code'" [inputVal]="donor_zipCodeInput" [width]="'90%'"
                           [maxLength]="20" [disabled]="this.readOnly"
        ></app-st-input-text>
        <br>
        <i class="webtext-black" style="font-size: 12px;">Include foundations that are give grants to recipients physically located in these cities.</i>
        <br>
        <app-st-span [inputVal]="'Donated Grants to these Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>

        <app-st-input-text *ngIf="this.readOnly" [idVal]="'donated-grants-cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'"
                           [disabled]="this.readOnly"
        ></app-st-input-text>
        <app-st-autocomplete-key-lookup *ngIf="!this.readOnly" [idVal]="'donated-grants-cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                        [items]="this.citiesAutocomplete"
        ></app-st-autocomplete-key-lookup>
        <br>

        <i class="webtext-black" style="font-size: 12px;">Include foundations that give grants to recipients physically located in this state.</i>
        <br>
        <app-st-span [inputVal]="'Donated Grants in this State: '" class="webtext-black-bold"></app-st-span>
        <app-st-select *ngIf="!this.readOnly" [idVal]="'dg-usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.donor_statesList"
        ></app-st-select>
        <app-st-input-text  *ngIf="this.readOnly" [idVal]="'dg-usa-state-text-id'" [label]="''" [placeHolderVal]="'Donated Grants to this State'"
                            [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>

        <i class="webtext-black" style="font-size: 12px;">Include foundations that gave grants to recipients in the selected tax year.</i>
        <br>
        <app-st-span [inputVal]="'Tax Year: '" class="webtext-black-bold"></app-st-span>
        <app-st-select *ngIf="!this.readOnly" [idVal]="'tax-year-dropdown-list-id'" [defaultOption]="'Select Tax Year'" [label]="''" [idKey]="'taxYear'" [displayKey]="'taxYear'" [valueKey]="'taxYear'" [inputArray]="this.taxYears"></app-st-select>
        <app-st-input-text  *ngIf="this.readOnly" [idVal]="'tax-year-text-id'" [label]="''" [placeHolderVal]="'Tax Year'"
                            [width]="'95%'" [disabled]="this.readOnly"></app-st-input-text>
        <br>
        <app-st-span [inputVal]="'Key Donors, Directors, and Staff: '" class="webtext-black-bold"></app-st-span>
        <app-st-autocomplete [idVal]="'donor-key-staff-text-id'" [label]="''" [placeHolderVal]="'Key Staff'" [inputVal]="donor_keyStaffInput"  [maxLength]="200" [width]="'95%'"
                             [items]="this.keyStaffAutocomplete" [multipleAllowed]="false" [disabled]="this.readOnly"
        ></app-st-autocomplete>
        <br>
        <!--
        <app-st-span [inputVal]="'Minimum Number of Years In Business: '" class="webtext-black-bold"></app-st-span>
        <app-st-input-text [idVal]="'min-years-in-business-text-id'" [label]="''" [placeHolderVal]="'Minimum Number of Years In Business'" [maxLength]="6" [width]="'95%'"></app-st-input-text>
        -->
        <!--
        <app-st-input-text [idVal]="'donor-counties-text-id'" [label]="''" [placeHolderVal]="'Counties'" [inputVal]="donor_countiesInput" [width]="'90%'"></app-st-input-text>
        <app-st-input-text [idVal]="'donor-counties-without-text-id'" [label]="''" [placeHolderVal]="'Without Counties'" [inputVal]="donor_countiesWithoutInput" [width]="'90%'"></app-st-input-text>
        -->

        <!--Cause Dropdown triggers the Giving Interest Dropdown-->
        <div *ngIf="!this.readOnly">
          <app-st-span [inputVal]="'Cause Category: '" class="webtext-black-bold"></app-st-span>
          <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList" (change)="updateCauseGivingInterestsDropdown()"></app-st-select>
          <br>
          <app-st-span [inputVal]="'Select the option of your search for the selected Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioAND3"
                   (click)="trackLogicalExpression('AND')" [checked]="logicalOperatorAnd">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioAND3">
              &nbsp;AND
            </label>
            &nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="'OR'" id="flexRadioOR3"
                   (click)="trackLogicalExpression('OR')" [checked]="logicalOperatorOr">
            <label class="form-check-label checkbox-text webtext-black" for="flexRadioOR3">
              &nbsp;OR
            </label>
          </div>
          <br>
          <!--Giving Interest Dropdown-->
          <app-st-span [inputVal]="'Cause Category Giving Interests: '" class="webtext-black-bold"></app-st-span><br>
          <app-st-select [idVal]="'cause-giving-interests-dropdown-list-id'" [defaultOption]="'Select your Cause Category Giving Interest'" [label]="''" [idKey]="'causeGivingInterestId'" [displayKey]="'givingInterestDisplayName'" [valueKey]="'givingInterestName'" [inputArray]="this.causeGivingInterestsDropdownList"></app-st-select>
          <br>
          <div class="col2 d-grid gap-2 d-md-flex">
            <app-st-button [idVal]="'cause-giving-interests-include-button-id'" [label]="'Add (+)'" [primary]="true"
                           (click)="this.addCauseGivingInterestFilter2(true)"></app-st-button>
          </div>
        </div>
        <br>
        <i class="webtext-black" style="font-size: 12px;">As you add your Cause Category Giving Interests, the list below will populate.</i>
        <div>
          <table class="table table-striped webtext-black" style="width:95%; border-radius: 10px">
            <thead>
            <tr>
              <th style="width:85%">Cause Category Giving Interest Query</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.donor_causeGivingInterestsList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="('OR' != row) && ('AND' != row) && !this.readOnly" (click)="onDeleteGivingInterest(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--
        <div>
          <br>
          <div class="chip" *ngFor="let row of this.donor_causeGivingInterestsList">
            {{row}}
            <span class="closebtn-chip" (click)="this.deleteGivingInterestChip3(row)">&times;</span>
          </div>
        </div>-->

        <br>
        <br>
        <!--Exclude these cause_giving_interests-->
        <!--
        <div>
          <br>
          <table class="table table-striped webtext-black" style="width:95%">
            <thead>
            <tr>
              <th style="width:85%">Exclude these Cause Category Giving Interest (s)</th>
              <th style="width:15%">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of this.donor_causeGivingInterestsWithoutList">
              <td>{{row}}</td>
              <td>
                <a *ngIf="!this.readOnly" (click)="onDeleteGivingInterestWithout(row)">
                  <i class="bi bi-trash"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>-->
        <!--
        <div>
          <br>
          <div class="chip" *ngFor="let row of this.donor_causeGivingInterestsWithoutList">
            {{row}}
            <span class="closebtn-chip" (click)="this.deleteGivingInterestWithoutChip3(row)">&times;</span>
          </div>
        </div>-->

        <br>
        <br>
        <div>
          <button id="'advanced-filters-button-id'" class="accordionParent webtext-black" (click)="this.toggleAdvancedFilters()"><b>Advanced Filters </b> <b *ngIf="!this.advancedFiltersButton"> (Click to expand) + </b><b *ngIf="this.advancedFiltersButton"> (Click to collapse) - </b></button>
          <br>
        </div>
        <div *ngIf="this.advancedFiltersButton" class="panel">
          <br>
          <div>
            <button id="'donor-total-assets-button-id'" class="accordion webtext-white" (click)="this.toggleDonorTotalAssetsFilter()"><b>Total Assets Range</b> <b *ngIf="!this.donor_totalAssetsButton"> + </b><b *ngIf="this.donor_totalAssetsButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_totalAssetsButton" class="panel">
            <div class="accordion-body" *ngFor="let totalAssetsRadioButton of donor_totalAssetsRadioButtons; let i9 = index">
              <div class="form-check">
                <input class="form-check-input" type="radio" value="{{totalAssetsRadioButton['assetRangeId']}}" id="flexRadioDonorTotalAssets-{{i9}}"
                       (click)="trackDonorTotalAssetsRange(i9)" [checked]="totalAssetsRadioButton['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexRadioDonorTotalAssets-{{i9}}">
                  {{totalAssetsRadioButton['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_totalAssetsButton" [idVal]="'see-less-total-assets-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorTotalAssetsFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <br>
          <div>
            <button id="'donor-total-income-button-id'" class="accordion webtext-black" (click)="this.toggleDonorTotalIncomeFilter()"><b>Total Income Range</b> <b *ngIf="!this.donor_totalIncomeButton"> + </b><b *ngIf="this.donor_totalIncomeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_totalIncomeButton" class="panel">
            <div class="accordion-body" *ngFor="let totalIncomeRadioButton of donor_totalIncomeRadioButtons; let i9 = index">
              <div class="form-check">
                <input class="form-check-input" type="radio" value="{{totalIncomeRadioButton['incomeRangeId']}}" id="flexRadioDonorTotalIncome-{{i9}}"
                       (click)="trackDonorTotalIncomeRange(i9)" [checked]="totalIncomeRadioButton['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexRadioDonorTotalIncome-{{i9}}">
                  {{totalIncomeRadioButton['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_totalIncomeButton" [idVal]="'see-less-total-income-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorTotalIncomeFilter()"></app-st-button>
            </div>
          </div>
          <br>

          <div>
            <button id="'donor-filing-req-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorFilingReqCodesFilter()"><b>Filing Req Codes</b> <b *ngIf="!this.donor_filingReqCodeButton"> + </b><b *ngIf="this.donor_filingReqCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_filingReqCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let filingReqCodeCheckbox of donor_filingReqCodeCheckboxes; let i5 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{filingReqCodeCheckbox['filingReqCodeId']}}" id="flexCheckCheckedDonorFilingReqCode-{{i5}}"
                       (click)="addValToDonorFilingReqCodes(i5)" [checked]="filingReqCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorFilingReqCode-{{i5}}">
                  {{filingReqCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_filingReqCodeButton" [idVal]="'see-less-filing-req-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorFilingReqCodesFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <div>
            <button id="'donor-foundation-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorFoundationCodesFilter()"><b>Foundation Codes</b> <b *ngIf="!this.donor_foundationCodeButton"> + </b><b *ngIf="this.donor_foundationCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_foundationCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let foundationCodeCheckbox of donor_foundationCodeCheckboxes; let i5 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{foundationCodeCheckbox['foundationCodeId']}}" id="flexCheckCheckedDonorFoundationCode-{{i5}}"
                       (click)="addValToDonorFoundationCodes(i5)" [checked]="foundationCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorFoundationCode-{{i5}}">
                  {{foundationCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_nteeCodeButton" [idVal]="'see-less-ntee-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorNteeCodesFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <div>
            <button id="'donor-ntee-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorNteeCodesFilter()"><b>NTEE Codes</b> <b *ngIf="!this.donor_nteeCodeButton"> + </b><b *ngIf="this.donor_nteeCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_nteeCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let nteeCodeCheckbox of donor_nteeCodeCheckboxes; let i6 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{nteeCodeCheckbox['nteeCodeId']}}" id="flexCheckCheckedDonorNteeCode-{{i6}}"
                       (click)="addValToDonorNteeCodes(i6)" [checked]="nteeCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorNteeCode-{{i6}}">
                  {{nteeCodeCheckbox['nteeCode']}}: {{nteeCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_nteeCodeButton" [idVal]="'see-less-ntee-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorNteeCodesFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <div>
            <button id="'donor-ntee-parent-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorNteeParentCodesFilter()"><b>NTEE Parent Codes</b> <b *ngIf="!this.donor_nteeParentCodeButton"> + </b><b *ngIf="this.donor_nteeParentCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_nteeParentCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let nteeParentCodeCheckbox of donor_nteeParentCodeCheckboxes; let i7 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{nteeParentCodeCheckbox['nteeParentCodeId']}}" id="flexCheckCheckedDonorNteeParentCode-{{i7}}"
                       (click)="addValToDonorNteeParentCodes(i7)" [checked]="nteeParentCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorNteeParentCode-{{i7}}">
                  {{nteeParentCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_nteeParentCodeButton" [idVal]="'see-less-ntee-parent-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorNteeParentCodesFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <div>
            <button id="'donor-organization-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorOrganizationCodesFilter()"><b>Organization Codes</b> <b *ngIf="!this.donor_organizationCodeButton"> + </b><b *ngIf="this.donor_organizationCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_organizationCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let organizationCodeCheckbox of donor_organizationCodeCheckboxes; let i8 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{organizationCodeCheckbox['organizationCodeId']}}" id="flexCheckCheckedDonorOrganizationCode-{{i8}}"
                       (click)="addValToDonorOrganizationCodes(i8)" [checked]="organizationCodeCheckbox['checked']" [disabled]="this.readOnly">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorFoundationCode-{{i8}}">
                  {{organizationCodeCheckbox['description']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_organizationCodeButton" [idVal]="'see-less-organization-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorOrganizationCodesFilter()"></app-st-button>
            </div>
          </div>
          <br>
          <div>
            <button id="'donor-return-type-codes-button-id'" class="accordion webtext-black" (click)="this.toggleDonorReturnTypeCodesFilter()"><b>Return Type Codes</b> <b *ngIf="!this.donor_returnTypeCodeButton"> + </b><b *ngIf="this.donor_returnTypeCodeButton"> - </b></button>
          </div>
          <div *ngIf="this.donor_returnTypeCodeButton" class="panel">
            <div class="accordion-body" *ngFor="let returnTypeCodeCheckbox of donor_returnTypeCodeCheckboxes; let i9 = index">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="{{returnTypeCodeCheckbox['returnTypeCodeId']}}" id="flexCheckCheckedDonorReturnTypeCode-{{i9}}"
                       (click)="addValToDonorReturnTypeCodes(i9)" [checked]="returnTypeCodeCheckbox['checked']" [disabled]="true">
                <label class="form-check-label checkbox-text webtext-black" for="flexCheckCheckedDonorReturnTypeCode-{{i9}}">
                  {{returnTypeCodeCheckbox['returnTypeCodeName']}}
                </label>
              </div>
            </div>
            <div>
              <app-st-button *ngIf="this.donor_returnTypeCodeButton" [idVal]="'see-less-return-type-code-button-id'" [label]="'^ See Less'" [primary]="true"
                             (click)="this.toggleDonorReturnTypeCodesFilter()"></app-st-button>
            </div>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Organization: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-asc-radio-button-id"
                   (click)="toggleCompanyNameAscButton()" [checked]="this.companyNameAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="company-name-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="company-name-desc-radio-button-id"
                   (click)="toggleCompanyNameDescButton()" [checked]="this.companyNameDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="company-name-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By City: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-asc-radio-button-id"
                   (click)="toggleCityAscButton()" [checked]="this.cityAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-desc-radio-button-id"
                   (click)="toggleCityDescButton()" [checked]="this.cityDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="city-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By State: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-asc-radio-button-id"
                   (click)="toggleStateAscButton()" [checked]="this.stateAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-desc-radio-button-id"
                   (click)="toggleStateDescButton()" [checked]="this.stateDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="state-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>
        <br>
        <div>
          <app-st-span [inputVal]="'Sort By Total Assets: '" class="webtext-black-bold"></app-st-span>
          <div>
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-asc-radio-button-id"
                   (click)="toggleTotalAssetsAscButton()" [checked]="this.totalAssetsAscRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="total-assets-asc-radio-button-id">
              &nbsp;ASCENDING
            </label>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <input class="form-check-input radio-button-properties" type="radio" value="false" id="total-assets-desc-radio-button-id"
                   (click)="toggleTotalAssetsDescButton()" [checked]="this.totalAssetsDescRadioButton" [disabled]="this.readOnly">
            <label class="form-check-label webtext-black" for="total-assets-desc-radio-button-id">
              &nbsp;DESCENDING
            </label>
          </div>
        </div>

      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
      <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
      <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button-delete-all *ngIf="!this.readOnly" [idVal]="'top-reset-filter-button2-id'" [label]="'Reset Filter'"
                                (click)="this.resetFilters()"></app-st-button-delete-all>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                    [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSubmit(false)"

      ></app-st-button>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                    [idVal]="'top-save-button-id'" [label]="'Submit and Apply'" [primary]="true"
                     (click)="this.onSubmit(true)"
      ></app-st-button>
    </div>
  </div>
</div>
